<div class="shape-container flex center flex--align-stretch">
  <div class="front-svg svg-wrapper" (click)="clickFront()">
    <svg class="dn-laptop-down grow" viewBox="0 0 300 200">
      <path
        d="M 280 4 L 300 4 M 300 196 L 280 196 Q 4 196 4 100 Q 4 4 280 4 M 100 150 Q 4 100 100 50"
        fill="transparent"
        stroke="black"
        stroke-width="2"
        vector-effect="non-scaling-stroke"
      ></path>
    </svg>
  </div>
  <div class="relative mini-map-container flex flex-1" #wrapper>
    <div class="z1 absolute fill grow" (click)="handleClick($event)"></div>

    <button #selectedArea class="selected-area absolute border rounded-medium" (keydown)="onKeyDown($event)"></button>
    <div class="flex dynamic-svg" #seatMapContainer>
      <svg [attr.viewBox]="svgViewBox" class="aircraft-seat-map" [attr.data-optimal-width]="svgWidth">
        <g [class]="'wing ' + rightWingClass" [attr.transform]="svgRightWing.transform">
          <polygon [attr.points]="svgRightWing.points" fill="#0C0243" />
        </g>
        <g [class]="'wing ' + leftWingClass" [attr.transform]="svgLeftWing.transform">
          <polygon [attr.points]="svgLeftWing.points" fill="#0C0243" />
        </g>

        <use [attr.href]="'#' + svgId" />

        <g [class]="'wing ' + rightWingClass + '-cover'" [attr.transform]="svgRightWing.transform">
          <polygon [attr.points]="svgRightWing.points" fill="white" />
        </g>
        <g [class]="'wing ' + leftWingClass + '-cover'" [attr.transform]="svgLeftWing.transform">
          <polygon [attr.points]="svgLeftWing.points" fill="white" />
        </g>
      </svg>
    </div>
  </div>

  <div class="back-svg svg-wrapper" (click)="clickBack()">
    <svg class="dn-laptop-down grow" viewBox="0 0 200 200">
      <path
        d="M 0 4 Q 196 0 196 100 Q 196 196 0 196"
        fill="transparent"
        stroke="black"
        stroke-width="2"
        vector-effect="non-scaling-stroke"
      ></path>
    </svg>
  </div>
</div>
